<template>
    <div>
        <van-nav-bar
      :title="t('parssord.title')"
      :border="false"
      class="custom-nav-bar"
      >
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="mt-[17px] mx-[11px]">
          <div class="text-[13px] color-[#FFFFFF]">{{ t('parssord.verificar') }}</div>
          <div class="color-[#5FB589] text-[10px] mt-[8px]">{{ t('parssord.setNewPasswordAfterVerify') }}</div>
          <div class="auth-input-row mt-[30px]" :class="{ 'input-error': passwordError }">
            <img
            :src="getAssetsFile('home/yaoshi.png')"
            alt=""
            class="h-[14px] w-[14px] mr-[10px]"
            @click="registerForm.password = ''"
          >
          <input
            v-model="registerForm.password"
            class="auth-input"
            :type="showRegisterPassword ? 'text' : 'password'"
            :placeholder="$t('parssord.password')"
            @input="onPasswordInput"
            @blur="validatePassword"
          >
          <img
            v-if="registerForm.password"
            :src="getAssetsFile('home/closes.png')"
            alt=""
            class="h-[11px] w-[11px]"
            @click="registerForm.password = ''"
          >
          <img
            v-if="showRegisterPassword"
            :src="getAssetsFile('home/Preview@2x.png')"
            alt=""
            class="h-[11px] w-[11px] ml-[10px] cursor-pointer"
            style="object-fit: contain;"
            @click="toggleRegisterPassword"
          >
          <img
            v-if="!showRegisterPassword"
            :src="getAssetsFile('home/Preview@2x (1).png')"
            alt=""
            class="h-[11px] w-[11px] ml-[10px] cursor-pointer"
            style="object-fit: contain;"
            @click="toggleRegisterPassword"
          >
        </div>
        <!-- 验证错误提示 -->
        <div v-if="passwordError" class="input-error-tip mt-[8px]">
          <img :src="getAssetsFile('home/@2x.png')" alt="" class="h-[11px] w-[11px] mr-[4px]">
          {{ passwordErrorMessage }}
        </div>
        <div class="flex justify-center items-center mt-[30px]">
        <div class="anniu" @click="anniu()" :class="{ 'auth-btn-disabled': isLoading }">
          {{ isLoading ? t('parssord.verifying') : t('parssord.confirm') }}
        </div>
        </div>
    </div>
    </div>
</template>
<script setup lang="ts">
import { Button } from "@/components/Button"
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import { checkUserPassword } from '@/api/game'
import { showToast } from 'vant'

const { t } = useI18n()
const router = useRouter()
const route = useRoute()

const onClickLeft = () => {
  router.push('/security')
}

const registerForm = ref({
  password: ''
})
const showRegisterPassword = ref(false)
const passwordError = ref(false)
const passwordErrorMessage = ref('')
const isLoading = ref(false)

const onPasswordInput = () => {
  registerForm.value.password = registerForm.value.password.trim()
  // 实时验证
  validatePassword()
}

const validatePassword = () => {
  const password = registerForm.value.password
  if (password && (password.length < 6 || password.length > 16)) {
    passwordError.value = true
    passwordErrorMessage.value = t('parssord.passwordLengthError')
  } else {
    passwordError.value = false
    passwordErrorMessage.value = ''
  }
}

function toggleRegisterPassword() {
  showRegisterPassword.value = !showRegisterPassword.value
}

// 验证登录密码
const anniu = async () => {
  // 验证密码
  if (!registerForm.value.password) {
    passwordError.value = true
    passwordErrorMessage.value = t('parssord.passwordRequired')
    return
  }

  if (passwordError.value) {
    return
  }

  try {
    isLoading.value = true

    // 调用验证登录密码接口
    const response = await checkUserPassword(registerForm.value.password)

    if (response.data === true) {
      // 根据URL参数决定跳转到哪个页面
      const redirect = route.query.redirect as string
      const fromPage = route.query.fromPage as string

      if (redirect === 'email') {
        // 验证成功后跳转到email页面
        router.push('/security/email')
      } else if (redirect === 'resetPassword') {
        // 验证成功后跳转到重置密码页面
        router.push('/security/resetPassword')
      } else if (redirect === 'senha') {
        // 验证成功后跳转到设置提现密码页面，并传递来源页面参数
        router.push({
          path: '/security/senha',
          query: { fromPage: fromPage }
        })
      } else {
        // 默认跳转到重置密码页面（保持向后兼容）
        router.push('/security/resetPassword')
      }

    } else {
      // 密码验证失败
      passwordError.value = true
      passwordErrorMessage.value = t('parssord.passwordIncorrect')
    }

  } catch (error) {
    passwordError.value = true
    passwordErrorMessage.value = t('parssord.verificationFailed')
  } finally {
    isLoading.value = false
  }
}
</script>
<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}
.auth-input-row {
display: flex;
border-radius: 6px;
align-items: center;
display: flex;
border:1px solid #349C75;
align-items: center;
padding: 0 11px;
margin-top: 20px;
transition: border-color 0.3s ease;
}
.auth-input-row.input-error {
border: 1px solid #ff4d4f !important;
}
.auth-img-placeholder {
width: 28px;
height: 28px;
background: #1a4d3a;
border-radius: 6px;
margin-right: 8px;
}
.auth-input {
flex: 1;
height: 40px;
border-radius: 8px;
border: none;
padding: 0 12px 0 0;
background: none;
color: #fff;
font-size: 12px;
caret-color: #50d38c;
}
.input-error-tip {
display: flex;
align-items: baseline;
color: #ff4d4f;
font-size: 12px;
}
input[type='checkbox'] {
accent-color: #50d38c;
}
.input-error {
border: 1px solid #ff4d4f !important;
}
.input-error-tip {
display: flex;
align-items: baseline;
color: #ff4d4f;
font-size: 12px;
}
.input-tip {
display: flex;
align-items: baseline;
color: #50d38c;
font-size: 12px;
}
.auth-btn-disabled {
background: #126736 !important;
cursor: not-allowed !important;
opacity: 0.6;
}

.auth-btn:disabled {
background: #126736 !important;
cursor: not-allowed !important;
opacity: 0.6;
}
input::placeholder {
color: #096;
font-size: 12px;
}
.anniu{
  width: 275px;
height: 35px;
background: linear-gradient(0deg, #379753 0%, #46C96D 100%);
border-radius: 11px;
color: #fff;
font-size: 13px;
text-align: center;
line-height:35px;
font-weight: bold;
}
</style>
<route lang="json5">
    {
      name: 'parssord',
      meta: {
        title: 'parssord',
        i18n: 'parssord'
      },
    }
</route>
